import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const UpdateIncome = async (FormData, IncomeID) => {
  try {
    const IncomeDocument = doc(db, "Incomes", IncomeID);

    const data = HelperForMetaData({
      ...FormData,
    });

    await updateDoc(IncomeDocument, data);

    return true;
  } catch (error) {
    console.log("Error Updating income", error);

    return false;
  }
};

export default UpdateIncome;
